import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "amount" }
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = { for: "type" }
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "transaction_code" }
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = { for: "transaction_date" }
const _hoisted_27 = { class: "card-footer text-center" }
const _hoisted_28 = { class: "btn-group" }
const _hoisted_29 = { class: "card card-success card-outline" }
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }, null, -1)
const _hoisted_33 = { class: "card-body row body-table-list" }
const _hoisted_34 = {
  class: "table-list",
  style: {"width":"-webkit-fill-available"},
  cellpadding: "3"
}
const _hoisted_35 = { style: {"padding":"10px"} }
const _hoisted_36 = { style: {"padding":"10px"} }
const _hoisted_37 = { style: {"padding":"10px"} }
const _hoisted_38 = { style: {"padding":"10px"} }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = { style: {"text-align":"center"} }
const _hoisted_42 = { style: {"text-align":"center"} }
const _hoisted_43 = { style: {"text-align":"center"} }
const _hoisted_44 = { class: "divForHoverItem" }
const _hoisted_45 = { class: "divHiddenText" }
const _hoisted_46 = { style: {"text-align":"center"} }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.payment")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.payment")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.page.payment")) + " | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.entity.amount")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.row.amount)), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("labels.entity.type")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.type === 1,
            'bg-warning': _ctx.row.type === 2
          }])
              }, _toDisplayString(_ctx.row.type === 1 ? _ctx.$t('labels.paymentType.type.stripe') : _ctx.$t('labels.paymentType.type.paypal')), 3)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.entity.transactionCode")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.transaction_code), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("labels.entity.transactionDate")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.row.transaction_date)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h3", _hoisted_31, [
              _hoisted_32,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.page.paymentAttempt")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("table", _hoisted_34, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.customer")), 1),
                _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("labels.entity.amount")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.type")), 1),
                _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("labels.entity.transactionCode")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.transactionDate")), 1),
                _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t("labels.entity.result")), 1),
                _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t("labels.entity.succeed")), 1)
              ]),
              (_ctx.row.payment_attempt)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.row.payment_attempt.customer?.name || '-'), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatNumber(_ctx.row.payment_attempt.amount)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", {
                'bg-success': _ctx.row.payment_attempt.type === 1,
                'bg-warning': _ctx.row.payment_attempt.type === 2
              }])
                      }, _toDisplayString(_ctx.row.payment_attempt.type === 1 ? _ctx.$t('labels.paymentType.type.stripe') : _ctx.$t('labels.paymentType.type.paypal')), 3)
                    ]),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.row.payment_attempt.transaction_code || '-'), 1),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.row.payment_attempt.transaction_date ? _ctx.formatDate(_ctx.row.payment_attempt.transaction_date) : '-'), 1),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.row.payment_attempt.result?.substring(0, 50) || '-') + " ", 1),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.row.payment_attempt.result?.substring(50)), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", {
                'bg-success': _ctx.row.payment_attempt.succeed,
                'bg-danger': !_ctx.row.payment_attempt.succeed
              }])
                      }, _toDisplayString(_ctx.row.payment_attempt.succeed ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}